import { 
  ALERT_RESET_REDUX,
  TOOGLE_ALERT, TOOGLE_ALERT_MODULE,
  TOOGLE_ALERT_INFO
} from '../actions/alert.actions'

const initState = {
  type: '',
  title: 'Unable to connect to the internet',
  icon: ["fas","wifi-slash"],
  show: false,
  disabledCloseButton: false,
  form: {},
  save: {
    mode: '',
    module: '',
    show: false,
    onSave: null,
    onDontSave: null,
  },
  info: {
    show: false,
    title: '',
    subtitle: '',
    type: ''
  }
}

const alertReducer = (state = initState, action) => {
  const { type, payload } = action
  const newState = { ...state }
  switch (type) {
    case ALERT_RESET_REDUX:
      return  JSON.parse(JSON.stringify({ ...initState }))
    case TOOGLE_ALERT:
        newState.show = payload.show
        newState.type = payload.type
        newState.title = payload.title
        newState.icon = payload.icon
        newState.form = payload.form
        newState.disabledCloseButton = payload.disabledCloseButton
      break     
    case TOOGLE_ALERT_MODULE:
      newState.save.show = payload.show
      newState.save.module = payload.module
      newState.save.mode = payload.mode
      newState.save.onSave = payload.onSave
      newState.save.onDontSave = payload.onDontSave
    break    
    case TOOGLE_ALERT_INFO:
      if (payload.show) {
        newState.info = {
          show: true,
          title: payload.title,
          subtitle: payload.subtitle,
          type: payload.type
        }
      } else {
        newState.info = {
          show: false,
          title: '',
          subtitle: '',
          type: ''
        }
      }
    break      
    default:
      break
  }

  return newState
}

export default alertReducer
